function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1254.24 1244.51l-433.094 0c-3.86103,-44.1626 -23.054,-85.5355 -54.6898,-117.173 -35.5736,-35.5725 -83.4556,-55.4138 -133.773,-55.4138 -50.3174,0 -98.1993,19.8402 -133.773,55.415 -31.1327,31.1327 -50.2146,71.6906 -54.4937,115.06 -139.675,-13.5473 -182.608,-90.8292 -182.608,-188.582 0,-79.9075 32.2087,-171.97 59.5146,-250.018 5.93032,-16.9512 11.6126,-33.1925 17.361,-50.726 9.81969,-29.954 23.061,-59.0126 42.4985,-81.4701 22.0311,-25.4563 50.7626,-41.9079 89.1296,-41.9079l702.175 0 16.2496 4.50118 480.452 283.503c7.85079,4.63111 15.8504,8.95512 23.7142,13.2047 48.6213,26.2725 93.2894,50.4118 93.2894,115.546l0 64.8095c0,36.6697 -14.987,69.9922 -39.124,94.128 -24.1382,24.1382 -57.4595,39.124 -94.1292,39.124l-21.7736 0c-3.86103,-44.1626 -23.0528,-85.5355 -54.691,-117.173 -35.5736,-35.5725 -83.4544,-55.4138 -133.772,-55.4138 -50.3185,0 -98.1993,19.8402 -133.773,55.415 -31.637,31.637 -50.8288,73.0075 -54.6898,117.171zm445.774 -190.07c17.6728,0 32.0008,-14.328 32.0008,-32.0008 0,-17.6728 -14.328,-32.0008 -32.0008,-32.0008l-121.634 0c-17.6728,0 -32.0008,14.328 -32.0008,32.0008 0,17.6728 14.328,32.0008 32.0008,32.0008l121.634 0zm-1338.82 -170.156l1148.51 13.4847 -345.845 -204.073 -693.553 0c-17.3232,0 -30.5469,7.71733 -40.8792,19.6559 -12.9272,14.9362 -22.4705,36.5103 -29.9977,59.4709 -4.80355,14.6528 -11.1898,32.9032 -17.8618,51.9756 -6.68504,19.1091 -13.6843,39.1146 -20.3764,59.4863z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M632.684 1103.93c43.4008,0 82.6985,17.5961 111.145,46.0418 28.4457,28.4469 46.0418,67.7445 46.0418,111.145 0,43.402 -17.5949,82.6997 -46.0418,111.147 -28.4469,28.4457 -67.7434,46.0418 -111.145,46.0418 -43.4032,0 -82.7009,-17.5961 -111.145,-46.0418 -28.4469,-28.4469 -46.0418,-67.7445 -46.0418,-111.147 0,-43.402 17.5949,-82.6985 46.0418,-111.145 28.4445,-28.4457 67.7422,-46.0418 111.145,-46.0418z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1442.7 1103.93c43.402,0 82.6985,17.5961 111.145,46.0418 28.4469,28.4469 46.0418,67.7445 46.0418,111.145 0,43.402 -17.5949,82.6997 -46.0418,111.147 -28.4469,28.4457 -67.7434,46.0418 -111.145,46.0418 -43.4032,0 -82.6997,-17.5949 -111.145,-46.0418 -28.4469,-28.4469 -46.0418,-67.7445 -46.0418,-111.147 0,-43.402 17.5949,-82.6985 46.0418,-111.145 28.4457,-28.4469 67.7422,-46.0418 111.145,-46.0418z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "328.56,854.479 1546.11,854.479 1546.11,918.48 328.56,918.48 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "1049.08,661.698 1049.08,886.479 985.076,886.479 985.076,661.698 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "789.873,661.698 789.873,886.479 725.872,886.479 725.872,661.698 "
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  width: 2048,
  height: 2048
});

var SvgCargoShip = function SvgCargoShip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCargoShip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CargoShip.5097854b.svg";
export { ForwardRef as ReactComponent };